import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Close from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';
// import socketIoClient from '../../../socket/socketConfig';
import BookAppointmentFilter from './BookAppointmentFilter';
import BookAppointmentSearch from './BookAppointmentSearch';
import BookAppointmentCheckout from './BookAppointmentCheckout';
import BookAppointmentConfirmation from './BookAppointmentConfirmation';
import ProviderRestrictedModal from './ProviderRestrictedModal';
// import PatientRestrictForProvider from './PatientRestrictForProvider';
import PatientRestrictForAppt from '../../SearchCheckout/PatientRestrictForAppt';
import {
  fetchProviders,
  bookAppointment,
  getFilterData,
  overBookedAppt,
} from '../../../services/api';
import {
  checkProviderRestrictedMode,
  checkBothPatientAndProviderId,
  checkProviderEligibleMode,
} from '../../../services/api/admin';
import * as authApi from '../../../services/api/auth';
import Backgroundscroll from '../../../Backgroundscroll';

function BookAppointmentModal(props) {
  const {
    patient = {},
    closeDialog,
    open,
    classes: { appBar, title },
  } = props;
  const scrollRef = React.useRef(null);

  const { enqueueSnackbar } = useSnackbar();
  const [currentAppointment, setCurrentAppointment] = useState({});
  const [currentProvider, setCurrentProvider] = useState({});
  const [currentTenancy, setCurrentTenancy] = useState({});
  const [referringProvider, setReferringProvider] = useState(null);
  const [providerList, setProviderList] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState(null);
  const [restrictReason, setRestrictReason] = useState('');
  const [images, setImages] = useState([]);
  const [showProviderRestrictedModal, setProviderRestrictedModal] =
    useState(false);
  const [showPatientRestrictModal, setShowPatientRestrictModal] =
    useState(false);
  const [loginUserInfo, setLoginUserInfo] = useState(null);
  const [providerFamily, setProviderFamily] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [overBookAlert, setOverBookAlert] = useState(false);
  // const [openDuplicateApptAlert, setOpenDuplicateApptAlert] = useState(false);
  const [offSetValue, setOffSetValue] = useState(0);
  const [providerSlotAvailable, setProviderSlotAvailable] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const currUser = await authApi.fetchCurrentUser();
        setLoginUserInfo(currUser);
      } catch (error) {
        console.log('error////////', error);
      }
    })();
  }, []);

  useEffect(() => {
    if (searchCriteria) {
      if (searchCriteria.noResult) {
        setProviderList([]);
        setIsLoading(false);
        return;
      }
      (async () => {
        scrollToTop();
        const { data } = await getFilterData(searchCriteria);
        setProviderList(data);
        setIsLoading(false);
      })();
    }
  }, [searchCriteria]);

  useEffect(() => {
    const shouldShowMsg =
      searchCriteria?.provider &&
      searchCriteria?.tenancyType !== 'both' &&
      providerList?.[0] &&
      (!providerList[0].selectedProviderSlot ||
        providerList[0].tenancies.length === 0);

    setProviderSlotAvailable(!shouldShowMsg);
  }, [providerList]);
  const scrollToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const onBackToSearch = () => {
    setOffSetValue(0);
    setProviderList([]);
    setShowFilters(true);
    setShowSearch(false);
    setShowCheckout(false);
    setShowConfirmation(false);
    setReferringProvider(null);
  };

  const onProviderSearchFilter = (searchSpecs) => {
    setShowFilters(false);
    setIsLoading(true);
    setShowSearch(true);
    setShowCheckout(false);
    setShowConfirmation(false);
    setSearchCriteria(searchSpecs);
  };

  const onCloseModal = () => {
    setProviderRestrictedModal(false);
  };

  const onClosePatientRestrictModal = () => {
    setShowPatientRestrictModal(false);
  };

  const onPageChange = (direction) => {
    const nextOffset =
      direction === 'next'
        ? searchCriteria.offSet + searchCriteria.limit
        : Math.max(searchCriteria.offSet - searchCriteria.limit, 0);
    setOffSetValue(nextOffset >= 0 ? nextOffset : 10);
    setSearchCriteria({
      ...searchCriteria,
      // offSet: nextOffset || 15,
      offSet: nextOffset >= 0 ? nextOffset : 10,
      limit: 10,
    });
    // scrollToTop();
  };

  const onAppointmentSelected = async ({ provider, tenancy, start }) => {
    const restriction = await checkProviderEligibleMode(
      provider.id,
      patient.id
    );
    // const now = new Date().getTime();
    // const then = new Date(patient.birthdate).getTime();
    // const Age =
    //   (now - then) / 1000 / 60 / 60 / 24 / 365
    // console.log(Age, patient.gender)

    setProviderFamily(provider.practice.name);
    setIsLoading(true);
    const statusCheck = await checkProviderRestrictedMode(provider.id);
    if (statusCheck.data === 'Provider is restricted by admin') {
      setProviderRestrictedModal(true);
      setIsLoading(false);
      return;
    }
    if (
      loginUserInfo &&
      loginUserInfo.administrator &&
      loginUserInfo.administrator.id
    ) {
      // if (statusCheck.data === 'Provider is restricted by admin') {
      //   setProviderRestrictedModal(true);
      //   setIsLoading(false);
      // } else {
        setCurrentTenancy(tenancy);
        setCurrentProvider(provider);
        setCurrentAppointment({ startTimestamp: start });
        setShowFilters(false);
        setShowSearch(false);
        setShowCheckout(true);
        setShowConfirmation(false);
        setIsLoading(false);
      // }
    }
    if (loginUserInfo && loginUserInfo.id === undefined) {
      const responseInfo = await checkProviderRestrictedMode(provider.id);
      if (responseInfo.data === 'Provider is restricted by admin') {
        setProviderRestrictedModal(true);
        setIsLoading(false);
      } else {
        setCurrentTenancy(tenancy);
        setCurrentProvider(provider);
        setCurrentAppointment({ startTimestamp: start });
        setShowFilters(false);
        setShowSearch(false);
        setShowCheckout(true);
        setShowConfirmation(false);
        setIsLoading(false);
      }
    }
    if (
      loginUserInfo &&
      loginUserInfo.provider &&
      loginUserInfo.provider.id !== undefined
    ) {
      const checkingPatient = await checkBothPatientAndProviderId(
        patient.id,
        provider.id
      );

      if (restriction.data.success === true) {
        setCurrentTenancy(tenancy);
        setCurrentProvider(provider);
        setCurrentAppointment({ startTimestamp: start });
        setShowFilters(false);
        setShowSearch(false);
        setShowCheckout(true);
        setShowConfirmation(false);
        setIsLoading(false);
      } else {
        setRestrictReason(restriction.data.data);
        // setProviderRestrictedModal(true)
        setShowPatientRestrictModal(true);
        setIsLoading(false);
      }

      if (statusCheck.data === 'Provider is restricted by admin') {
        if (checkingPatient.data === 'Patient have access') {
          if (restriction.data.success === true) {
            // setRestrictReason("restriction.data.data");
            // setProviderRestrictedModal(true)
            // setShowPatientRestrictModal(true);
            // setIsLoading(false);
            setCurrentTenancy(tenancy);
            setCurrentProvider(provider);
            setCurrentAppointment({ startTimestamp: start });
            setShowFilters(false);
            setShowSearch(false);
            setShowCheckout(true);
            setShowConfirmation(false);
            setIsLoading(false);
          } else {
            setRestrictReason(restriction.data.data);
            // setProviderRestrictedModal(true)
            setShowPatientRestrictModal(true);
            setIsLoading(false);
          }
        }
      }
    } else if (
      loginUserInfo &&
      loginUserInfo.patient &&
      loginUserInfo.patient.id !== undefined
    ) {
      const checkingInfo = await checkBothPatientAndProviderId(
        loginUserInfo.patient.id,
        provider.id
      );

      //patient having acesss
      if (checkingInfo.data === 'Patient have access') {
        if (restriction.data.success === true) {
          setCurrentTenancy(tenancy);
          setCurrentProvider(provider);
          setCurrentAppointment({ startTimestamp: start });
          setShowFilters(false);
          setShowSearch(false);
          setShowCheckout(true);
          setShowConfirmation(false);
          setIsLoading(false);
        } else {
          setRestrictReason(restriction.data.data);
          // setProviderRestrictedModal(true)
          setShowPatientRestrictModal(true);
          setIsLoading(false);
        }
      }
    }
  };
  const onReferralSelected = ({ referredProvider, referringProvider }) => {
    setReferringProvider(referringProvider);
    onAppointmentSelected({ provider: referredProvider, tenancy: {} });
  };

  const onNotesFieldChange = (event) => {
    setCurrentAppointment({
      ...currentAppointment,
      portalNotes: event.target.value,
    });
  };

  // the reason that there is an option to surpress the api is that
  // this code is really bad but really entangled with this component and its children.
  // so rather than conforming to the bad practices it uses I'm kaing another function
  // for submissions inside one of its chidlren which gets used under certain conditions
  // unfortunately this function is still responsible for some how the UX functions so we need
  //  to call it from its child on submit but we dont want to do the api request, just the UX stuff
  const onSubmit = async (makeApiCall = true) => {
    if (makeApiCall) {
      currentAppointment.attachments = images.map((i) => i.dataUrl);
      const appointmentParams = {
        patient,
        appointment: currentAppointment,
        tenancy: currentTenancy,
        provider: currentProvider,
      };
      try {
        // Check user timezone
        const currentUserTimezone =
          Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Convert UTC to America/New_York time, automatically handling DST
        const estTime = DateTime.fromISO(currentAppointment.startTimestamp, {
          zone: 'UTC',
        }).setZone('America/New_York');
        const apptHour = estTime.hour;
        
        if (
          currentUserTimezone !== 'America/New_York' ||
          (apptHour < 6 || apptHour > 22)
        ) {
          alert(
            '⚠️ Time Zone Mismatch Detected:\n' +
              'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
          );
          return;
        }
        //Check for existing appointments.
        const bookedAppt = await overBookedAppt({
          start: currentAppointment.startTimestamp,
          tenancyId: currentTenancy.id,
          providerId: currentProvider.id,
        });
        const isApptOverBooked = bookedAppt.some(
          (obj) => obj.isCurrentTimeInRange === true
        );
        if (!isApptOverBooked) {
          const responseMessage = await bookAppointment(appointmentParams);
          if(responseMessage.msg === 'Patient already has an appointment on this day') {
            //  setOpenDuplicateApptAlert(true);
            alert("This patient already has an appointment booked at Westside Family Medicine on this date.  Only one appointment per practice per day is allowed.  Please choose another day, or cancel the other appointment and then re-attempt your booking.");
            return;
           }
           else{
          enqueueSnackbar('Appointment booked!', {
            preventDuplicate: true,
            autoHideDuration: 3000,
          });
        }
          // socketIoClient.emit('message', {
          //   message: 'auto-refresh-Appointments',
          //   id: loginUserInfo && loginUserInfo.id,
          // });
        } else {
          setOverBookAlert(true);
        }
      } catch (err) {
        enqueueSnackbar('Unable to book appointment. Please try again.');
      }
    }
    setShowFilters(false);
    setShowSearch(false);
    setShowCheckout(false);
    setShowConfirmation(true);
  };

  const setPropImages = (data) => {
    setImages(data);
  };

  const onCloseDialog = () => {
    closeDialog();
    setShowFilters(true);
    setShowSearch(false);
    setShowCheckout(false);
    setShowConfirmation(false);
    setReferringProvider(null);
  };

  const closeAlert = () => {
    setOverBookAlert(false);
  };

  // const closeDuplicateApptAlert = ()=>{
  //   setOpenDuplicateApptAlert(false);
  // }

  return (
    <FullScreenDialog fullScreen={open} open={open} onClose={onCloseDialog}>
      <div
        ref={scrollRef}
        style={{
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <AppBar color="default" className={appBar}>
          <Toolbar>
            <Typography variant="h6" color="inherit" className={title}>
              Book New Appointment
            </Typography>

            <Button color="inherit" onClick={onCloseDialog}>
              <Close />
            </Button>
          </Toolbar>
        </AppBar>

        {!showFilters && (
          <Toolbar>
            <Button
              color="primary"
              variant="contained"
              onClick={onBackToSearch}
            >
              Back
            </Button>
          </Toolbar>
        )}
        {!providerSlotAvailable && (
          <div
            style={{
              paddingTop: '20px',
              paddingLeft: '20px',
              color: '#ff5656',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            The requested provider is not available for the selected appointment
            type. Please either request a different appointment or choose
            another provider listed below.
          </div>
        )}

        {showFilters && (
          <BookAppointmentFilter
            providerSearchFilter={onProviderSearchFilter}
          />
        )}

        {showSearch && (
          <BookAppointmentSearch
            onPageChange={onPageChange}
            providers={providerList}
            handleSelectAppointment={onAppointmentSelected}
            handleRefferalSelected={onReferralSelected}
            Loading={isLoading}
            offSetValue={offSetValue}
          />
        )}
        {showCheckout && (
          <BookAppointmentCheckout
            viewOnly={false}
            provider={currentProvider}
            setPropImages={setPropImages}
            imagesProps={images}
            patient={patient}
            tenancy={currentTenancy}
            appointment={currentAppointment}
            referringProvider={referringProvider}
            bookAppointment={onSubmit}
            overBookAlert={overBookAlert}
            closeAlert={closeAlert}
            // openDuplicateApptAlert={openDuplicateApptAlert}
            // closeDuplicateApptAlert={closeDuplicateApptAlert}
            onNotesFieldChange={onNotesFieldChange}
            onReferringProviderSelected={(userId) => {
              setCurrentAppointment({
                ...currentAppointment,
                createdBy: userId,
              });
            }}
          />
        )}
        {!showFilters &&
          !isLoading &&
          providerList?.length === 0 &&
          (offSetValue ? (
            <p
              style={{
                textAlign: 'center',
                marginTop: '6em',
                fontSize: '20px',
              }}
            >
              New Provider Coming soon....
            </p>
          ) : (
            <p
              style={{
                textAlign: 'center',
                fontSize: '20px',
                fontSize: '20px',
                marginTop: '6em',
                padding: '0px 20px',
              }}
            >
              Unfortunately we don't currently have any providers meeting your
              search criteria but our network is expanding every day! Help us
              grow by letting us know a specialty or a provider you'd like us a
              add and we'll be happy do our best to include them in our
              network..&nbsp;
              <a
                href={
                  process.env.REACT_APP_HOMEPAGE_URL +
                  '/for-providers/?formType=referProvider#contactForm'
                }
                style={{
                  color: '#007bff',
                  textDecoration: 'underline',
                  fontWeight: 500,
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here
              </a>{' '}
              to send us the details and we'll take it from there!
            </p>
          ))}
        {showConfirmation && (
          <BookAppointmentConfirmation
            provider={currentProvider}
            patient={patient}
            tenancy={currentTenancy}
            appointment={currentAppointment}
            referringProvider={referringProvider}
          />
        )}

        {showProviderRestrictedModal && (
          <ProviderRestrictedModal
            open={showProviderRestrictedModal}
            onClose={onCloseModal}
            providerFamily={providerFamily}
          />
        )}
        {showPatientRestrictModal && (
          <PatientRestrictForAppt
            open={showPatientRestrictModal}
            onClose={onClosePatientRestrictModal}
            restrictReason={restrictReason}
          />
        )}
      </div>
    </FullScreenDialog>
  );
}

BookAppointmentModal.propTypes = {
  patient: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

const styles = () => ({
  appBar: {
    position: 'relative',
  },
  title: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
});

const fullScreenDialogStyles = (theme) => ({
  paperFullScreen: {
    width: '55%',
    height: '80%',
    position: 'fixed',
    top: '15%',
    [theme.breakpoints.down('lg')]: {
      width: '80%',
    },
  },
});

const FullScreenDialog = Backgroundscroll(
  withStyles(fullScreenDialogStyles)(Dialog)
);

export default withStyles(styles)(BookAppointmentModal);
